import { alpha } from '@mui/material/styles';

/* https://kovart.github.io/dashed-border-generator/ */
export const dashhed4 = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='%23B7BBC2FF' stroke-width='2' stroke-dasharray='4%2c 8' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e")`;

const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const COMMON = {
  common: { black: '#000000', white: '#FFFFFF' },
  divider: alpha(GREY[500], 0.24),
  action: {
    hover: '#F3F5F6',
    selected: '#F3F5F6',
    disabled: '#E7E9EC',
    disabledBackground: '#F9FAFB',
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

// 전자결재 전용 상태 컬러 가이드. (theme/palette.ts 는 MUI 테마용으로, 결재 컴포넌트는 이 컬러 가이드를 참조해서 자체 스타일링)
export const APPROVAL_PALETTE = {
  primary: {
    main: '#0066CC',
    dark: '#004A99',
    light: '#3384D6',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#F55060',
    dark: '#D63848',
    light: '#F77380',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#43B16F',
    dark: '#368859',
    light: '#6AC28C',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FEAE00',
    dark: '#D49300',
    light: '#FEBE33',
    contrastText: '#FFFFFF',
  },
};

export default function palette(themeMode: 'light' | 'dark') {
  const light = {
    ...COMMON,
    mode: 'light',
    text: {
      primary: GREY[800],
      secondary: GREY[600],
      disabled: GREY[500],
    },
    background: { paper: '#FFFFFF', default: '#FFFFFF', neutral: GREY[200] },
    action: {
      ...COMMON.action,
      active: GREY[600],
    },
  } as const;

  // 앱 웹뷰 다크 모드 전용 (styles/appDarkMode.ts 의 --dk-* 와 같은 값 — 앱 네이티브 다크 팔레트)
  const dark = {
    ...COMMON,
    mode: 'dark',
    divider: '#2F3136',
    // MUI 기본 다크 primary(#90caf9) 대신 앱 accent
    primary: { main: '#4A94FF', dark: '#2F7BEA', light: '#7AB1FF', contrastText: '#FFFFFF' },
    text: {
      primary: '#F2F3F5',
      secondary: '#9197A1',
      disabled: '#62676F',
    },
    background: {
      paper: '#1C1D21',
      default: '#111214',
      neutral: '#26282D',
    },
    action: {
      ...COMMON.action,
      active: '#9197A1',
      hover: 'rgba(255, 255, 255, 0.06)',
      selected: 'rgba(255, 255, 255, 0.08)',
      disabled: '#4A4E55',
      disabledBackground: '#26282D',
    },
  } as const;

  return themeMode === 'light' ? light : dark;
}
